var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"map_cn",attrs:{"id":"map_cn"}}),_c('div',{staticClass:"bgc map_but"},[_vm._v(" "+_vm._s(_vm.mapBut)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }